import React from "react";
import { Row, Col } from "react-bootstrap";
import { Health, StorageServices, UserServices } from "../../../services";
import {
  AlertWidget,
  MainBoxTool,
  SectionTitle,
  StatisticWidget,
  ModalIntro,
} from "../../common";
import {
  StatisticTypeWidget,
  StatisticWidgetVariantValue,
  AlertWidgetType,
  E_ContractType,
} from "../../common/types";
import "./MainHome.css";
import { FormattedMessage } from "react-intl";
import { es, en, pt } from "../../../../lang";

export default class MainHome extends React.Component<any, any> {
  prevLanguage: string;

  constructor(props: any) {
    super(props);

    this.state = {
      currentUser: StorageServices.GetCookieUser(),
      warningsHealth: null,
      showModal: StorageServices.GetCookieUser().ShowOnBoard,
      selectedLanguage: localStorage.getItem("readysizelocale") || "en",
    };

    this.prevLanguage = this.state.selectedLanguage;
  }

  openModal = (event: any) => {
    const selectedLanguage = event.currentTarget.getAttribute(
      "data-selected-language"
    );
    this.setState({ showModal: true, selectedLanguage });
  };

  closeModal = () => {
    let user = StorageServices.GetCookieUser();

    user.ShowOnBoard = false;

    // Save the updated user back to the cookie
    StorageServices.SetCookieUser(user);

    // Update the state
    this.setState({ showModal: false });
  };

  componentDidMount(): void {
    const readysizelocale = localStorage.getItem("readysizelocale") || "en";
    const user = StorageServices.GetCookieUser();

    this.setState({
      selectedLanguage: readysizelocale,
      currentUser: user,
      warningsHealth: null,
      showModal: user.ShowOnBoard,
      contractType:
        user.Contract && user.Contract.Name === "Free"
          ? E_ContractType.FREE
          : E_ContractType.NONE,
    });

    try {
      Health.GetWarningsHealth().then((response: any) => {
        if (response.Status === 200) {
          this.setState({ warningsHealth: response.Content });
        }
      });
    } catch (error) {
      console.log(error);
    }

    this.prevLanguage = this.state.selectedLanguage;
  }

  componentDidUpdate(): void {
    if (this.state.selectedLanguage !== this.prevLanguage) {
      this.forceUpdate();
      this.prevLanguage = this.state.selectedLanguage;
    }
  }

  handleLanguageChange = (readysizelocale: any) => {
    let messages;
    if (readysizelocale === "es") {
      messages = es;
    } else if (readysizelocale === "en") {
      messages = en;
    } else if (readysizelocale === "pt") {
      messages = pt;
    }
    localStorage.setItem("readysizelocale", readysizelocale);
    this.props.changeLanguage(readysizelocale, messages);
  };

  contentInternalActionTools() {
    return (
      <>
        <Col>
          <Row className="my-3 login-section">
            <Col xs={5} className="login-section-image-one">
              <img
                src="/img/icon-size-guide.png"
                alt="Settings Size Guides"
                width={80}
                className="main-guideconfig-image"
              />
            </Col>
            <Col xs={7}>
              <div>
                <span className="font-fitprenda-action-description">
                  <FormattedMessage id="home-configure" />
                </span>
              </div>
              <div className="mt-4">
                <a
                  href="/readysize/sizes-guides"
                  className="link-fitprenda-action pt-4 fitprenda-mainhome-configurar-guia"
                >
                  <FormattedMessage id="home-configure-guide" />
                </a>
              </div>
            </Col>
          </Row>
        </Col>

        <div className="box-fitprenda-internal-separator"></div>

        <Col>
          <Row className="my-3 login-section">
            <Col xs={5} className="login-section-image-two">
              <img
                src="/img/icon-products.png"
                alt="Settings Products"
                width={97}
                className="main-loadprod-image"
              />
            </Col>
            <Col xs={7}>
              <div>
                <span className="font-fitprenda-action-description">
                  <FormattedMessage id="home-upload" />
                  <br />
                  <br className="d-xxl-none" />
                </span>
              </div>
              <div className="fitprenda-mainhome-carga-productos">
                <a
                  href="/readysize/products"
                  className="link-fitprenda-action pt-5"
                >
                  <FormattedMessage id="home-upload-products" />
                </a>
              </div>
            </Col>
          </Row>
        </Col>

        <div className="box-fitprenda-internal-separator"></div>

        <Col>
          <Row className="my-3 login-section">
            <Col xs={5} className="login-section-image-three">
              <img
                src="/img/icon-statistics.png"
                alt="View Dashboard"
                width={97}
                className="mt-auto pt-3 main-stats-image"
              />
            </Col>
            <Col xs={7}>
              <div>
                <span className="font-fitprenda-action-description">
                  <FormattedMessage id="home-review" />
                </span>
              </div>
              <div className="mt-5">
                <a
                  href="/readysize/charts"
                  className="link-fitprenda-action pt-5"
                >
                  <FormattedMessage id="home-see-statistics" />
                </a>
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  }

  render() {
    // console.log('CURRENT STATE', this.state);

    return (
      <>
        <Row>
          <Col className="login-title">
            <SectionTitle title="ready-size-start" />
          </Col>
        </Row>

        {/* Access */}
        <Row className="justify-content-center">
          <Col
            xs={8}
            xl={9}
            lg={12}
            className="fitprenda-mainboxtool-main-container"
            md={12}
          >
            <MainBoxTool
              title={
                <>
                  <FormattedMessage
                    id="home-greeting"
                    // defaultMessage="Hello,"
                  />
                  {this.state.currentUser.Name
                    ? ` ${this.state.currentUser.Name}`
                    : ` ${this.state.currentUser.split("@")[0]}`}
                  !
                </>
              }
              subtitle="home-subtitle"
              children={this.contentInternalActionTools()}
            />
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col xs={8} xl={9} className="text-left main-attention">
            <SectionTitle title="home-title-attention" />
          </Col>
        </Row>

        {/* Alerts*/}
        <Row className="justify-content-center mt-2 px-3">
          <Col xs={8} xl={9} className="para-prestar-atencion-container">
            <Row>
              <Col>
                <AlertWidget
                  title="ready-size-products-withoutguide"
                  values={{
                    count:
                      this.state.warningsHealth?.NoSizeGuideProducts || "0",
                  }}
                  description="home-product-guide-description"
                  urlLink="/readysize/products/list-wsg"
                  urlText="ready-size-do-now"
                  typeAlert={AlertWidgetType.CENTIMETER}
                  includeNewLine={true}
                />
              </Col>
              <Col className="mx-3">
                <AlertWidget
                  title="home-unrecognized-products"
                  values={{
                    count: this.state.warningsHealth?.UnknowProducts || "0",
                  }}
                  description="home-unrecognized-product-description"
                  urlLink="/readysize/products/list-wsg"
                  urlText="ready-size-do-now"
                  typeAlert={AlertWidgetType.TSHIRT}
                  includeNewLine={true}
                />
              </Col>
              <Col>
                <AlertWidget
                  title="home-inactive-products-title"
                  values={{
                    count: this.state.warningsHealth?.Inactive || "0",
                  }}
                  description="home-inactive-products-description"
                  urlLink="/readysize/products/list-wsg"
                  urlText="home-inactive-review"
                  typeAlert={AlertWidgetType.WARNING}
                  includeNewLine={true}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col xs={8} xl={9} className="statistics-main">
            <SectionTitle
              title="home-title-statistics"
              clarification="home-title-statistics-clarification"
            />
          </Col>
        </Row>

        {/* statistics */}
        <Row className="justify-content-center mt-2 px-3">
          <Col xs={8} xl={9} className="text-left statistics-container">
            <Row>
              <Col>
                <StatisticWidget
                  text="ready-size-recommended-sizes"
                  value={
                    <>
                      {this.state.warningsHealth?.TotalPredictions || "0"}
                      {this.state.contractType === E_ContractType.FREE && (
                        <span className="smaller-font"> / 500</span>
                      )}
                    </>
                  }
                  valueVariant={StatisticWidgetVariantValue.REGULAR}
                  typeWidget={StatisticTypeWidget.SUNGLASSES}
                  helper="home-widget-recommended-helper"
                  contractType={this.state.contractType}
                />
              </Col>
              <Col className="mx-3">
                <StatisticWidget
                  text="ready-size-found-size"
                  value={`${
                    this.state.warningsHealth
                      ?.TotalPredictionsPercentageAccepts || "0"
                  }%`}
                  valueVariant={StatisticWidgetVariantValue.SUCCESS}
                  typeWidget={StatisticTypeWidget.STARSTRUCK}
                  helper="home-widget-found-helper"
                  contractType={this.state.contractType}
                />
              </Col>
              <Col>
                <StatisticWidget
                  text="ready-size-didnt-found-size"
                  value={`${
                    this.state.warningsHealth
                      ?.TotalPredictionsPercentageNoAccepts || "0"
                  }%`}
                  valueVariant={StatisticWidgetVariantValue.DANGER}
                  typeWidget={StatisticTypeWidget.FROWNING}
                  helper="home-widget-didnt-find-helper"
                  contractType={this.state.contractType}
                />
              </Col>
            </Row>
          </Col>
          {/* <Col>
            <button
              onClick={this.openModal}
              data-selected-language={this.state.selectedLanguage}
            >
              Modal Intro
            </button>
          </Col> */}
          {this.state.showModal && (
            <ModalIntro
              key={this.state.selectedLanguage} // Add this line
              closeModal={this.closeModal}
              selectedLanguage={this.state.selectedLanguage}
            />
          )}
        </Row>
        {/* <br className="d-xxl-none d-sm-block" /> */}
      </>
    );
  }
}
